<div role="group" [attr.aria-label]="getResponseLabel()" data-ui-name="Decimal delim" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-decimal-delim">
  
  <ng-container *ngIf="element.isFixedCoefficientSign">
    <span *ngIf="element.isNegativeCoefficient" style="margin-right: 0.3em;">&minus;</span>
  </ng-container>
  <ng-container *ngIf="!element.isFixedCoefficientSign">
    <div style="display:inline-block; margin-right: 0.3em;">
      <div class="custom-dropdown" style="padding: 0; height: 1.5em" [class.no-pointer-events]="isLocked">
        <button class="dropdown-header" (click)="toggleCoefficientSignDropdown()"
          [attr.aria-label]="getSignTriggerLabel('coefficient')" aria-haspopup="true"
          [attr.aria-expanded]="isCoefficientSignDropdownOpen" [attr.aria-controls]="getSignMenuId('coefficient')"
          #coefficientDropdownTrigger="cdkOverlayOrigin" cdkOverlayOrigin data-ui-name="Toggle Coefficient Sign Dropdown" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-toggle-coefficient-sign-dropdown">
          <span *ngIf="coefficientSignSelected">{{ coefficientSignSelected === '-' ? '−' : coefficientSignSelected }}</span>
          <span *ngIf="!coefficientSignSelected" style="font-size: 0.6em;" class="chevron">
            <i *ngIf="isCoefficientSignDropdownOpen" class="fas fa-chevron-up" name="dropdown-icon-up" aria-hidden="true"></i>
            <i *ngIf="!isCoefficientSignDropdownOpen" class="fas fa-chevron-down" name="dropdown-icon-down" aria-hidden="true"></i>
          </span>
        </button>
        <ng-template cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="coefficientDropdownTrigger"
          [cdkConnectedOverlayOpen]="isCoefficientSignDropdownOpen"
          [cdkConnectedOverlayHasBackdrop]="false"
          [cdkConnectedOverlayOffsetY]="4"
        >
          <div class="custom-dropdown-menu" role="group" [id]="getSignMenuId('coefficient')"
            [attr.aria-label]="getSignLabel('coefficient')" (keydown.escape)="closeSignMenu($event, 'coefficient')" data-ui-name="Close Sign Menu" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-close-sign-menu">
            <button (click)="selectCoefficientSign('+')" class="dropdown-item"
              [attr.aria-label]="getSignOptionLabel('coefficient', '+')" [attr.aria-pressed]="coefficientSignSelected === '+'"
              #coefficientDropdownFirstButton data-ui-name="Select Coefficient Sign" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-select-coefficient-sign">+</button>
            <button (click)="selectCoefficientSign('-')" class="dropdown-item"
              [attr.aria-label]="getSignOptionLabel('coefficient', '-')" [attr.aria-pressed]="coefficientSignSelected === '-'" data-ui-name="Select Coefficient Sign" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-select-coefficient-sign-0045902">&minus;</button>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>
  
  <ng-container *ngIf="element.isFixedWhole">
    <span>{{element.whole}}</span>
  </ng-container>
  <ng-container *ngIf="!element.isFixedWhole">
    <span *ngFor="let digitInput of wholeDigitInput; let listIndex = index;">
      <input 
        #digitInput
        [readonly]="this.isLocked"
        [attr.aria-label]="getDigitLabel('whole', listIndex)"
        type="text" 
        class="input digit-input" 
        [class.is-compact]="isSupportCompactInputStyle()"
        [formControl]="digitInput" 
        (focus)="onNumericInputFocusIn(digitInput)"
        (blur)="onNumericInputFocusOut()"
        [style.margin-left]="listIndex == 0 ? '0' : '0.3em'"
        [maxlength]="1"
        (keydown)="onDigitInputKeyDown($event, listIndex, 'whole')"
        [style.font-size]="getFontSizeForInput()" 
        style="vertical-align:middle; text-align:center"  data-ui-name="Digit input" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-digit-input">
    </span>
  </ng-container>
  <span style="margin-left:0.3em; margin-right:0.3em;">
    <tra slug="decimal_delim"></tra>
  </span>
  <ng-container *ngIf="element.isFixedFractional">
    <span>{{element.fractional}}</span>
  </ng-container>
  <ng-container *ngIf="!element.isFixedFractional">
    <span *ngFor="let digitInput of fractionalDigitInput; let listIndex = index;">
      <input 
        #digitInput 
        [readonly]="this.isLocked"
        [attr.aria-label]="getDigitLabel('fractional', listIndex)"
        type="text" 
        class="input digit-input" 
        [class.is-compact]="isSupportCompactInputStyle()"
        [formControl]="digitInput" 
        (focus)="onNumericInputFocusIn(digitInput)"
        (blur)="onNumericInputFocusOut()"
        [style.margin-left]="listIndex == 0 ? '0' : '0.3em'"
        [maxlength]="1"
        (keydown)="onDigitInputKeyDown($event, listIndex, 'fractional')"
        [style.font-size]="getFontSizeForInput()" 
        style="vertical-align:middle; text-align:center"  data-ui-name="Digit input" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-digit-input-afc7825">
    </span>
  </ng-container>
  <span style="margin-left: 0.3em; margin-right: 0.3em;">&times; 10</span>
  
  <ng-container *ngIf="element.isFixedExponent">
    <span *ngIf="element.isNegativeExponent"><sup>&minus;</sup></span>
    <span><sup>{{element.exponent}}</sup></span>
  </ng-container>
  <ng-container *ngIf="!element.isFixedExponent">
    
    <span style="vertical-align: 1em;">
      
      <ng-container *ngIf="element.isFixedExponentSign">
        <span *ngIf="element.isNegativeExponent" style="margin-right: 0.3em;">&minus;</span>
      </ng-container>
      <ng-container *ngIf="!element.isFixedExponentSign">
        <div style="display:inline-block; margin-right: 0.3em;" [style.font-size.em]="getExponentFontSizeFactor()">
          <div class="custom-dropdown" style="padding: 0; height: 1.5em" [class.no-pointer-events]="isLocked">
            <button class="dropdown-header" (click)="toggleExponentSignDropdown()"
              [attr.aria-label]="getSignTriggerLabel('exponent')" aria-haspopup="true"
              [attr.aria-expanded]="isExponentSignDropdownOpen" [attr.aria-controls]="getSignMenuId('exponent')"
              #exponentDropdownTrigger="cdkOverlayOrigin" cdkOverlayOrigin data-ui-name="Toggle Exponent Sign Dropdown" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-toggle-exponent-sign-dropdown">
              <span *ngIf="exponentSignSelected">{{ exponentSignSelected === '-' ? '−' : exponentSignSelected }}</span>
              <span *ngIf="!exponentSignSelected" style="font-size: 0.6em;" class="chevron">
                <i *ngIf="isExponentSignDropdownOpen" class="fas fa-chevron-up" name="dropdown-icon-up" aria-hidden="true"></i>
                <i *ngIf="!isExponentSignDropdownOpen" class="fas fa-chevron-down" name="dropdown-icon-down" aria-hidden="true"></i>
              </span>
            </button>
            <ng-template cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="exponentDropdownTrigger"
              [cdkConnectedOverlayOpen]="isExponentSignDropdownOpen"
              [cdkConnectedOverlayHasBackdrop]="false"
              [cdkConnectedOverlayOffsetY]="4"
            >
              <div class="custom-dropdown-menu" role="group" [id]="getSignMenuId('exponent')"
                [attr.aria-label]="getSignLabel('exponent')" (keydown.escape)="closeSignMenu($event, 'exponent')" data-ui-name="Close Sign Menu" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-close-sign-menu-37ab4f3">
                <button (click)="selectExponentSign('+')" class="dropdown-item"
                  [attr.aria-label]="getSignOptionLabel('exponent', '+')" [attr.aria-pressed]="exponentSignSelected === '+'"
                  #exponentDropdownFirstButton data-ui-name="Select Exponent Sign" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-select-exponent-sign">+</button>
                <button (click)="selectExponentSign('-')" class="dropdown-item"
                  [attr.aria-label]="getSignOptionLabel('exponent', '-')" [attr.aria-pressed]="exponentSignSelected === '-'" data-ui-name="Select Exponent Sign" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-select-exponent-sign-a5042cf">&minus;</button>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
      
      <span *ngFor="let digitInput of exponentDigitInput; let listIndex = index;" [style.font-size.em]="getExponentFontSizeFactor()">
        <input 
          #digitInput 
          [readonly]="this.isLocked"
          [attr.aria-label]="getDigitLabel('exponent', listIndex)"
          type="text" 
          class="input digit-input" 
          [class.is-compact]="isSupportCompactInputStyle()"
          [formControl]="digitInput" 
          (focus)="onNumericInputFocusIn(digitInput)"
          (blur)="onNumericInputFocusOut()"
          [style.margin-left]="listIndex == 0 ? '0' : '0.3em'"
          [maxlength]="1"
          (keydown)="onDigitInputKeyDown($event, listIndex, 'exponent')"
          [style.font-size]="getFontSizeForInput()" 
          style="vertical-align:middle; text-align:center"  data-ui-name="Digit input" data-ui-component="element-render-scientific-notation" data-testid="element-render-scientific-notation-digit-input-454769d">
      </span>
    </span>
  </ng-container>
    
</div>
